let host: string;

export function getHost() {
  if (host) {
    return host;
  }

  const qs = new URLSearchParams(window.location.search);
  const hostParam = qs.get("host");

  return hostParam as string;
}
